import Component from "@glimmer/component";
import { service } from "@ember/service";
import { withoutPrefix } from "discourse/lib/get-url";
import ModMarketBanner from "./mod-market-banner";

export default class ModMarketContextualBanner extends Component {
  @service router;

  get gameKey() {
    return this.args.outletArgs?.model?.gameKey;
  }

  get context() {
    if (this.gameKey) {
      return `game:${this.gameKey}`;
    }

    const pathname = withoutPrefix(
      new URL(this.router.currentURL || "/", window.location.origin).pathname
    );
    if (pathname === "/" || pathname === "/latest" || pathname === "/hot") {
      return "home";
    }

    return null;
  }

  get usesPeekLayout() {
    return Boolean(this.gameKey) || this.context === "home";
  }

  <template>
    {{#if this.context}}
      <div class="mod-market-contextual-banner">
        <ModMarketBanner
          @context={{this.context}}
          @layout={{if this.usesPeekLayout "peek"}}
        />
      </div>
    {{/if}}
  </template>
}
